import { selectorFamily, atom } from 'recoil';
import { AgreementsService } from 'api';
import flatArray from 'utils/general/flatArray';
import isObeMovable from 'utils/obes/isObeMovable';
export const getRemovableCustomerVehiclesRequestIdState = atom({
  key: 'getRemovableCustomerVehiclesRequestIdState',
  default: 0
});
const getRemovableVehicles = selectorFamily({
  key: 'getRemovableVehicles',
  get: customerId => async ({
    get
  }) => {
    let vehicles = [];
    get(getRemovableCustomerVehiclesRequestIdState);
    if (!customerId) return vehicles;
    try {
      const agreementsAndVehicles = await AgreementsService.getAgreementsWithObEsAndVehiclesForCustomer({
        customerId,
        body: {}
      });
      if (agreementsAndVehicles.results) {
        vehicles = agreementsAndVehicles.results.filter(content => content.obes).map(content => content.obes?.map(obe => ({
          obeId: obe.obeId,
          obeNumber: obe.obeNumber,
          obeStatus: obe.obeStatus,
          replacedBy: obe.replacedBy,
          agreementName: content.name,
          ...obe.vehicle
        })).filter(vehicle => vehicle.registrationNumber).filter(obe => isObeMovable(obe))).reduce((arr, element) => arr?.concat(Array.isArray(element) ? flatArray(element) : element), []);
        return vehicles;
      }
    } catch (e) {
      return undefined;
    }
    return vehicles;
  }
});
export default getRemovableVehicles;